module.exports = __webpack_public_path__ + "img/product_mb_02.f2e8e95.webp";